<nz-layout>
    <nz-header>
    </nz-header>
    <nz-content>
        <div >
            <div class="complication"><app-complication class="content" /></div>
        </div>
    </nz-content>
</nz-layout>
